import { ThemeProvider } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import theme from "../utils/Theme";
import HelpCenterHeader from "./HelpCenterHeader";

const HelpCenterLayout = () => {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state?.auth).userInfo;
  const token = useSelector((state) => state?.auth).accessToken;

  return (
    <ThemeProvider theme={theme}>
      {
        <div className="flex">
          <HelpCenterHeader />
          <div className="relative h-screen flex flex-1 flex-col overflow-y-auto xl:pt-[100px] pt-[72px] pb-[26px]">
            <Outlet />
          </div>
        </div>
      }
    </ThemeProvider>
  );
};

export default HelpCenterLayout;
